import { Inject, Injectable } from '@angular/core';
import { FIREBASE_APP } from 'ag-common-svc/lib/injections/firebase-app';
import { FirebaseApp } from 'firebase/app';
import { CommonFireStoreDao, QueryParam, WhereFilterOperandKeys } from 'ag-common-svc/lib/dao/CommonFireStoreDao.dao';
import { map, Observable } from 'rxjs';
import { DYNAMIC_PAGE_LINK_PREFIX } from '@ag-common-lib/lib/constants/path.constants';

@Injectable({
  providedIn: 'root',
})
export class PortalPagesService {
  readonly fsDao: CommonFireStoreDao<any>;
  private readonly portalLinkCollectionPath = 'menu-items';
  private readonly dynamicPageLinkPrefix = DYNAMIC_PAGE_LINK_PREFIX;

  constructor(@Inject(FIREBASE_APP) fireBaseApp: FirebaseApp) {
    this.fsDao = new CommonFireStoreDao<any>(fireBaseApp);
  }

  getPortalPagesList = () => {
    const qp: QueryParam[] = [];
    return this.fsDao.getList(this.portalLinkCollectionPath, qp, { sortField: 'order' });
  };

  /**
   * Returns the first `menu-items` record matching a dynamic page id.
   * Dynamic page links are stored as `/pages/dynamic/:dbId` in `menu-items.link`.
   */
  getMenuItemByDynamicPageId(pageDbId: string): Observable<any | undefined> {
    if (!pageDbId) {
      return new Observable(sub => {
        sub.next(undefined);
        sub.complete();
      });
    }
    const link = `${this.dynamicPageLinkPrefix}${pageDbId}`;
    const qp: QueryParam[] = [new QueryParam('link', WhereFilterOperandKeys.equal, link)];
    return this.fsDao.getList(this.portalLinkCollectionPath, qp).pipe(map(list => (list ?? [])?.[0]));
  }

  /**
   * @deprecated Use `getMenuItemByDynamicPageId`. This method name was misleading and its query was incorrect.
   */
  getPortalPageById(pageId: string) {
    return this.getMenuItemByDynamicPageId(pageId);
  }
}
